import React from "react"
import textboxRight from "../../images/featureSection/textbox_right.png"
import textboxLeft from "../../images/featureSection/textbox_left.png"
import pointBg from "../../images/featureSection/pointBg.png"
import css from "./featuresSection.module.css"
import useDeviceQueries from "../../hooks/useDeviceQueries"
import { findContentByLabel } from "../../utils/findContentByLabel"

const FeatureBox = ({ imgSrc, imgAlt, title, description }) => (
  <div className={css.featureBox}>
    <img src={imgSrc} alt={imgAlt} className={css.featureImage} />
    <div className={css.featureContent}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
)

const FeatureBoxMob = ({
  imgSrc,
  imgAlt,
  title,
  description,
  alignment,
  leftPosition,
}) => (
  <div
    className={`${css.featureBox} ${
      alignment === "right" ? css.alignRight : css.alignLeft
    }`}
  >
    <img src={imgSrc} alt={imgAlt} className={css.featureImage} />
    <div className={css.featureContent} style={{ left: leftPosition }}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
)

const FeaturesSection = ({ data }) => {
  const { isTablet, isMobile } = useDeviceQueries()
    const leftTitle1 = findContentByLabel(data, "section2_left_feature_title_1") || ""
    const leftTitle2 = findContentByLabel(data, "section2_left_feature_title_2") || ""
    const leftTitle3 = findContentByLabel(data, "section2_left_feature_title_3") || ""
    const leftDesc1 = findContentByLabel(data, "section2_left_feature_desc_1") || ""
    const leftDesc2 = findContentByLabel(data, "section2_left_feature_desc_2") || ""
    const leftDesc3 = findContentByLabel(data, "section2_left_feature_desc_3") || ""
    const rightTitle1 = findContentByLabel(data, "section2_right_feature_title_1") || ""
    const rightTitle2 = findContentByLabel(data, "section2_right_feature_title_2") || ""
    const rightTitle3 = findContentByLabel(data, "section2_right_feature_title_3") || ""
    const rightDesc1 = findContentByLabel(data, "section2_right_feature_desc_1") || ""
    const rightDesc2 = findContentByLabel(data, "section2_right_feature_desc_2") || ""
    const rightDesc3 = findContentByLabel(data, "section2_right_feature_desc_3") || ""
  

  const leftFeatures = [
    {
      imgSrc: textboxLeft,
      imgAlt: "textbox left",
      title: leftTitle1,
      description: leftDesc1,
    },
    {
      imgSrc: textboxLeft,
      imgAlt: "textbox left",
      title: leftTitle2,
      description: leftDesc2,
    },
    {
      imgSrc: textboxLeft,
      imgAlt: "textbox left",
      title: leftTitle3,
      description: leftDesc3,
    },
  ]

  const rightFeatures = [
    {
      imgSrc: textboxRight,
      imgAlt: "textbox right",
      title: rightTitle1,
      description: rightDesc1,
    },
    {
      imgSrc: textboxRight,
      imgAlt: "textbox right",
      title: rightTitle2,
      description: rightDesc2,
    },
    {
      imgSrc: textboxRight,
      imgAlt: "textbox right",
      title: rightTitle3,
      description: rightDesc3,
    },
  ]

  const orderedFeatures_mob = [
    {
      imgSrc: textboxLeft,
      imgAlt: "textbox left",
      title: leftTitle1,
      description: leftDesc1,
    },
    {
      imgSrc: textboxRight,
      imgAlt: "textbox right",
      title: rightTitle1,
      description: rightDesc1,
    },
    {
      imgSrc: textboxLeft,
      imgAlt: "textbox left",
      title: leftTitle2,
      description: leftDesc2,
    },
    {
      imgSrc: textboxRight,
      imgAlt: "textbox right",
      title: rightTitle2,
      description: rightDesc2,
    },
    {
      imgSrc: textboxLeft,
      imgAlt: "textbox left",
      title: leftTitle3,
      description: leftDesc3,
    },
    {
      imgSrc: textboxRight,
      imgAlt: "textbox right",
      title: rightTitle3,
      description: rightDesc3,
    },
  ]

  if (isMobile || isTablet) {
    return (
      <div className={css.featuresSection_mob}>
        <div className={css.centerSection}>
          <img
            src={pointBg}
            alt="Center Graphic"
            className={css.centerImage_mob}
          />
          <div className={css.centerContent_mob}>
            <h3>24小時</h3>
            <h3>網上自助申請</h3>
          </div>
        </div>

        {orderedFeatures_mob.map((feature, index) => (
          <FeatureBoxMob
            key={index}
            {...feature}
            alignment={index % 2 === 0 ? "right" : "left"}
            leftPosition={index % 2 === 0 ? "46%" : "55%"} // Alternating left position
          />
        ))}
      </div>
    )
  } else {
    return (
      <div className={css.featuresSection}>
        <div className={css.leftSection}>
          {leftFeatures.map((feature, index) => (
            <FeatureBox key={index} {...feature} />
          ))}
        </div>

        <div className={css.centerSection}>
          <img src={pointBg} alt="Center Graphic" className={css.centerImage} />
          <div className={css.centerContent}>
            <h3>24小時</h3>
            <h3>網上自助申請</h3>
          </div>
        </div>

        <div className={css.rightSection}>
          {rightFeatures.map((feature, index) => (
            <FeatureBox key={index} {...feature} />
          ))}
        </div>
      </div>
    )
  }
}

export default FeaturesSection
